export default __webpack_public_path__ + "static/media/history-image1.d91c83dd.jpg";